/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Message_SentInputs */

const en_sync_message_sent = /** @type {(inputs: Sync_Message_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent, waiting for the outcome`)
};

/**
* | output |
* | --- |
* | "Sent, waiting for the outcome" |
*
* @param {Sync_Message_SentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const sync_message_sent = /** @type {((inputs?: Sync_Message_SentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Message_SentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_sync_message_sent(inputs)
});